import {createRoot} from 'react-dom/client';
import {Flux} from '@nlabs/arkhamjs';
import {FluxContext} from '@nlabs/arkhamjs-utils-react';
import {Gotham} from '@nlabs/gothamjs';
import {Metropolis} from '@nlabs/metropolisjs';

import {HomePage} from './pages/HomePage';
import {ArticlePage} from './pages/ArticlePage';
import {ArchivePage} from './pages/ArchivePage';
import {AboutPage} from './pages/AboutPage';
import {SectionPage} from './pages/SectionPage';
import {sectionPath, sections} from './data/sections';
import {articleLoader} from './routes/articleLoader';
import {createMetropolisConfig} from './config/metropolisConfig';
import {publicArticleEndpoint} from './services/articles/reaktorArticleClient';
import {homepageStore} from './stores/homepageStore';
import './styles/main.css';

const rootElement = document.getElementById('app');

if(!rootElement) throw new Error('Missing #app root container.');

const metropolisConfig = createMetropolisConfig(publicArticleEndpoint(window.location.hostname));

const config = {
  app: {
    name: 'chicago-sentinel-times',
    title: 'Chicago Sentinel Times'
  },
  displayMode: 'light' as const,
  routes: [
    {analytics: {route: '/', title: 'Home', viewId: 'home'}, path: '/', element: <HomePage />},
    {analytics: {route: '/about', title: 'About', viewId: 'about'}, path: 'about', element: <AboutPage />},
    {analytics: {route: '/archive', title: 'Archive', viewId: 'archive'}, path: 'archive', element: <ArchivePage />},
    ...sections.map((section) => ({
      analytics: {route: sectionPath(section), title: section.label, viewId: `section.${section.slug}`},
      path: sectionPath(section),
      element: <SectionPage section={section} />
    })),
    {
      analytics: {route: '/:section/:slug', title: 'Article', viewId: 'article.detail'},
      path: ':section/:slug',
      element: <ArticlePage />,
      loader: articleLoader
    }
  ],
  stores: [homepageStore]
};

createRoot(rootElement).render(
  <FluxContext.Provider value={{flux: Flux}}>
    <Metropolis config={metropolisConfig}>
      <Gotham config={config} />
    </Metropolis>
  </FluxContext.Provider>
);
